import React from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import { FormattedMessage } from "react-intl";
import { Subscribe } from "unstated";

import PaymentDataContainer from "../../Stores/PaymentDataContainerStore";
import InvoiceDataContainer from "../../Stores/InvoiceDataContainerStore";
import { CreditCardPaymentContainer } from "./";
import { myUtilities } from "../../Utils";

class PaymentMethodsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.ACHRef = React.createRef();
    this.CCRef = React.createRef();
    this.isPaymentModeSet = false;
    this.state = {
      showPaymentMethodFailureModal: false,
    };
  }
  showCardPaymentIFrame = (data) => {
    this.props.setSelected("loading");
    data.setCreditCardCheck(true);
  };
  chooseSelectedButton = (name) => {
    if (this.props.selected.localeCompare(name) == 0) {
      return "payment-options-button-selected";
    } else return "payment-options-button";
  };
  showOrDismissAlert = (data) => {
    if (!data.state.showToast) {
      data.setAlertShow(true);
    }
    setTimeout(() => data.setAlertShow(false), 1250);
  };
  showACHPaymentForm = (invData, paymentData) => {
    this.props.setSelected("ACH");
    let totalAmt = invData.getTotalInvoiceAmount(invData.state.invoices);
    invData.setState({
      total: totalAmt,
    });
    paymentData.setTotalConvenienceFeeAndSurcharge(null, null);
  };
  validatePaymentModes = (data, paymentData) => {
    if (data.state.isAchEnabled === true) this.isPaymentModeSet = true;
    else if (data.state.isCCEnabled === true && !this.isPaymentModeSet) {
      this.showCardPaymentIFrame(paymentData);
      this.isPaymentModeSet = true;
    } else if (
      data.state.isAchEnabled === false &&
      data.state.isCCEnabled === false &&
      !this.isPaymentModeSet
    ) {
      this.isPaymentModeSet = true;
      this.setState({
        showPaymentMethodFailureModal: true,
      });
    }
  };
  render() {
    return (
      <Subscribe to={[PaymentDataContainer]}>
        {(data) => (
          <Subscribe to={[InvoiceDataContainer]}>
            {(invdata) => (
              <Col className="payment-options-button-group">
                <CreditCardPaymentContainer />
                <button
                  ref={this.ACHRef}
                  className={this.chooseSelectedButton("ACH")}
                  onClick={() => {
                    this.showACHPaymentForm(invdata, data);
                  }}
                  disabled={!invdata.state.isAchEnabled}
                >
                  {myUtilities.accountSpecificLanguage("paymentmethods.bankaccount","Bank Account")}
                </button>

                {/* <button className={this.chooseSelectedButton('DEBIT')} onClick={() => {this.showOrDismissAlert(data)}}>
                      Debit Card
                    </button> */}

                <button
                  ref={this.CCRef}
                  className={this.chooseSelectedButton("CC")}
                  onClick={() => {
                    this.showCardPaymentIFrame(data);
                  }}
                  disabled={!invdata.state.isCCEnabled}
                >
                  {myUtilities.accountSpecificLanguage("paymentmethods.creditcard","Credit Card")}
                </button>
                {this.validatePaymentModes(invdata, data)}
                <Modal show={this.state.showPaymentMethodFailureModal} centered>
                  <Modal.Body>
                  {myUtilities.accountSpecificLanguage("paymentmethods.alldisabled",
                    "All payment methods disabled, please contact admin for further details"
                  )}
                  </Modal.Body>
                </Modal>
              </Col>
            )}
          </Subscribe>
        )}
      </Subscribe>
    );
  }
}

export default PaymentMethodsContainer;
